/**
 * Wraps every <table> rendered inside a `@include wysiwyg` content area in a
 * scrollable div, so wide tables (e.g. from the privacy policy page) get
 * horizontal scroll on mobile instead of breaking layout — see
 * `.wysiwyg-table-scroll` / `& table { min-width: 600px; }` in
 * src/styles/_mixins.scss.
 *
 * Selector list mirrors every current `@include wysiwyg;` consumer — add a
 * new container here whenever a block starts using that mixin.
 */

const WYSIWYG_CONTAINERS = [
	'.simple-text__content',
	'.image-text__content',
	'.quote__content',
	'.blog-heading__text',
	'.product-hero__legal-content',
	'.product-tabs__content',
	'.category-intro-text',
	'.category-seo-text__block',
];

const tables = document.querySelectorAll(
	WYSIWYG_CONTAINERS.map((selector) => `${selector} table`).join(', ')
);

tables.forEach((table) => {
	const wrapper = document.createElement('div');
	wrapper.className = 'wysiwyg-table-scroll';

	table.parentNode.insertBefore(wrapper, table);
	wrapper.appendChild(table);
});
